/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LiveScorecardsQueryVariables = {|
  eventId: string,
  roundNumber?: ?number,
|};
export type LiveScorecardsQueryResponse = {|
  +liveScorecardSummaries: ?{|
    +event: ?{|
      +tournament: {|
        +officialName: string
      |}
    |},
    +nextRoundSalaryTitle: ?string,
    +playerSummaries: ?$ReadOnlyArray<?{|
      +scorecardId: ?string,
      +player: ?{|
        +id: string,
        +firstName: ?string,
        +lastName: ?string,
        +dkPlayer: ?{|
          +id: string
        |},
      |},
      +nextRoundSalary: ?number,
      +roundToPar: ?string,
      +eventToPar: ?string,
      +accDrives: ?number,
      +goodDrives: ?number,
      +accApps: ?number,
      +goodApps: ?number,
      +puttDist: ?number,
      +dkScore: ?number,
      +leaderboardPos: ?string,
    |}>,
  |}
|};
export type LiveScorecardsQuery = {|
  variables: LiveScorecardsQueryVariables,
  response: LiveScorecardsQueryResponse,
|};
*/


/*
query LiveScorecardsQuery(
  $eventId: ID!
  $roundNumber: Int
) {
  liveScorecardSummaries(eventId: $eventId, roundNumber: $roundNumber) {
    event {
      tournament {
        officialName
        id
      }
      id
    }
    nextRoundSalaryTitle
    playerSummaries {
      scorecardId
      player {
        id
        firstName
        lastName
        dkPlayer {
          id
        }
      }
      nextRoundSalary
      roundToPar
      eventToPar
      accDrives
      goodDrives
      accApps
      goodApps
      puttDist
      dkScore
      leaderboardPos
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "roundNumber"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "eventId",
    "variableName": "eventId"
  },
  {
    "kind": "Variable",
    "name": "roundNumber",
    "variableName": "roundNumber"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "officialName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nextRoundSalaryTitle",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "PGATourEventPlayerScorecardSummaryType",
  "kind": "LinkedField",
  "name": "playerSummaries",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scorecardId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PGATourPlayerType",
      "kind": "LinkedField",
      "name": "player",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PlayerType",
          "kind": "LinkedField",
          "name": "dkPlayer",
          "plural": false,
          "selections": [
            (v4/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextRoundSalary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roundToPar",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventToPar",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accDrives",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "goodDrives",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accApps",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "goodApps",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "puttDist",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dkScore",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "leaderboardPos",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LiveScorecardsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PGATourEventScorecardSummaryType",
        "kind": "LinkedField",
        "name": "liveScorecardSummaries",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourEventType",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PGATourTournamentType",
                "kind": "LinkedField",
                "name": "tournament",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LiveScorecardsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PGATourEventScorecardSummaryType",
        "kind": "LinkedField",
        "name": "liveScorecardSummaries",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourEventType",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PGATourTournamentType",
                "kind": "LinkedField",
                "name": "tournament",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d88083a95c42ed6c544488cb0ab5a246",
    "id": null,
    "metadata": {},
    "name": "LiveScorecardsQuery",
    "operationKind": "query",
    "text": "query LiveScorecardsQuery(\n  $eventId: ID!\n  $roundNumber: Int\n) {\n  liveScorecardSummaries(eventId: $eventId, roundNumber: $roundNumber) {\n    event {\n      tournament {\n        officialName\n        id\n      }\n      id\n    }\n    nextRoundSalaryTitle\n    playerSummaries {\n      scorecardId\n      player {\n        id\n        firstName\n        lastName\n        dkPlayer {\n          id\n        }\n      }\n      nextRoundSalary\n      roundToPar\n      eventToPar\n      accDrives\n      goodDrives\n      accApps\n      goodApps\n      puttDist\n      dkScore\n      leaderboardPos\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a19bc08ad81a18ed0ebe7c3068db3520';

module.exports = node;
